import { computePosition, flip, offset } from '@floating-ui/dom'

// 取得產品資料
export const getData = async () => {
	const response = await fetch('./json/data.json')
	const data = await response.json()
	return data || {}
}

// 取得縣市資料
export const getCounties = async () => {
  const response = await fetch('./json/countries.json')
  const data = await response.json()
  return data || []
}

// 輸入框選單
export const useInputSelect = () => {
  const selects = document.querySelectorAll('.input-select')
  if (!selects.length) return

  selects.forEach((select) => {
    const input = select.parentElement?.querySelector('.input')
    if (!input) return

    computePosition(input, select, {
      placement: 'bottom',
      middleware: [offset(12), flip()],
    }).then(({x, y}) => {
      Object.assign(select.style, {
        left: `${x}px`,
        top: `${y}px`,
      })
    })
  })
}

export const useFormRules = () => {
  function required(value) {
    return value !== null && value !== undefined && String(value).trim() !== ''
  }

  function checkPhone(value) {
    return /^09\d{8}$/.test(value)
  }

  function checkEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
  }

  function checkAddress(value) {
    return this.county && this.area && required(value)
  }

  return {
    required,
    checkPhone,
    checkEmail,
    checkAddress,
  }
}

export const useAnchorToError = () => {
  const getErrorOffsetTop = () => {
    const errorElement = document.querySelector('.form-item__helper')?.closest('.form-item')
    const errorElementOffset = errorElement?.getBoundingClientRect().top
    return errorElementOffset ?
      errorElementOffset + window.scrollY - (document.querySelector('.header')?.getBoundingClientRect().height || 0) :
      0
  }

  window.scrollTo({
    top: getErrorOffsetTop(),
    behavior: 'smooth',
  })
}